export default __webpack_public_path__ + "static/media/DD.252a781d.svg";